module.exports = __webpack_public_path__ + "img/button-center-green.408c7f8.png";